import { Injectable, inject } from '@angular/core';
import { Actions, createEffect } from '@ngrx/effects';
import { filter, tap } from 'rxjs';
import { NotificationService } from '../services/notification.service';

@Injectable()
export class NotificationEffects {
  private readonly actions$ = inject(Actions);
  private readonly notifications = inject(NotificationService);

  handleFailures$ = createEffect(
    () =>
      this.actions$.pipe(
        filter((action) => action.type.endsWith('Failure')),
        tap((action) => {
          // `error` is already an i18n key (from `extractError`). The shared
          // NotificationService translates it and dedupes against the HTTP
          // error interceptor so a 403 does not toast twice.
          const error = (action as { error?: string }).error ?? 'errors.unknown';
          this.notifications.error(error);
        }),
      ),
    { dispatch: false },
  );
}
